import type { FeaturesResponse, AdminFeaturesResponse, AdminFeatureResponse } from '@/types'
import { request } from './client'

export async function getFeatures(): Promise<FeaturesResponse> {
  return request<FeaturesResponse>('/features')
}

export async function getAdminFeatures(): Promise<AdminFeaturesResponse> {
  return request<AdminFeaturesResponse>('/admin/features')
}

export async function createAdminFeature(key: string): Promise<AdminFeatureResponse> {
  return request<AdminFeatureResponse>('/admin/features', {
    method: 'POST',
    body: { key },
  })
}

export async function updateAdminFeature(
  key: string,
  actionType: 'enable' | 'disable',
  targetType?: string,
  targetValue?: string | number,
): Promise<AdminFeatureResponse> {
  return request<AdminFeatureResponse>(`/admin/features/${encodeURIComponent(key)}`, {
    method: 'PATCH',
    body: {
      actionType,
      targetType: targetType || 'boolean',
      targetValue,
    },
  })
}

export async function deleteAdminFeature(key: string): Promise<void> {
  await request<void>(`/admin/features/${encodeURIComponent(key)}`, { method: 'DELETE' })
}
